export default __webpack_public_path__ + "img/bZLyQxZI.504692f0.svg";